import React from 'react'
import logo from './logo.png'
import { TypeAnimation } from 'react-type-animation'
import Legitimacy from './legitimacy'
import Features from './features'
import Profits from './profits'
import Earnings from './earnings'
import Ending from './ending'
import referral from './referral.png'
import education from './education.png'
import staking from './staking.png'
import timeline from './timeline.png'
import about from './about.png'
import contact from './contact.png'

const Contact = () => {
    return (
        <div>
            <div className='container-fluid' style={{ backgroundColor: "#23153c" }}>
                {/* <div className="d-flex justify-content-center"> */}

                <div className="row">
                    <div className="px-3 px-md-5 col-md-6 order-md-1 order-2">
                        <div className="py-md-5">
                            <div className="py-5">
                                <div>
                                    <h1 className='text-light display-4' style={{ fontWeight: 'bold' }}>Feel Free To                              </h1>

                                    {/* <h1 className='' >
                                        <TypeAnimation
                                            sequence={[
                                                // Same substring at the start will only be typed once, initially
                                                'WEALTH',
                                                1000,
                                                'LIFE',
                                                1000,
                                                'DREAMS',
                                                1000,
                                                'FORTUNES',
                                                1000,
                                                'PLANS',
                                                1000,

                                                'GOALS',
                                                1000,
                                            ]}
                                            speed={50}

                                            className="text-light display-4"
                                            style={{ fontWeight: 'bold' }}
                                            repeat={Infinity}
                                        /></h1> */}
                                    <h1 className='text-light display-4' style={{ fontWeight: 'bold' }}>Contact Us</h1>
                                    <p className="text-light display-6">Our support team is ready to answer your questions and provide the help you need.
                                    </p>
                                    <p className="text-light display-6">Also, check our social media
                                        <br />
                                        <div className='pt-3'>
                                <a style={{textDecoration:"none"}} href="https://www.youtube.com/@sft-f2f" target='_blank'><i style={{color:"white"}} class="fa-brands fa-youtube m-2"></i></a>
                                <a style={{textDecoration:"none"}} href="https://www.youtube.com/@sft-f2f" target='_blank'><i  style={{color:"white"}} class="fa-brands fa-facebook m-2"></i></a>
                                <a style={{textDecoration:"none"}} href="https://www.youtube.com/@sft-f2f" target='_blank'> <i  style={{color:"white"}} class="fa-brands fa-instagram m-2"></i></a>
                                    </div>
                                    </p>
                                    {/* <p className="text-light h4">SFT's Decentralized Smart Contract Platform</p> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-md-2 order-1 justify-content-center d-flex">
                        <img src={contact} class="brand-image p-md-none" alt="..." />
                    </div>
                </div>


            </div>

            <div className="container-fluid px-md-5 py-md-5">
                <Ending />

            </div>
        </div>
    )
}

export default Contact